(function () {
  "use strict";
  if (window.TMCartDrawerFooter) {
    window.TMCartDrawerFooter.refresh();
    return;
  }

  var drawer = null;
  var observer = null;
  var pendingFrame = null;
  var shortViewport = window.matchMedia("(max-height: 520px)");

  function observe() {
    if (drawer && observer) {
      observer.observe(drawer, {
        childList: true,
        subtree: true
      });
    }
  }

  function placeFooter() {
    if (!drawer || !drawer.isConnected) return;
    var container = drawer.querySelector(".cart-drawer__container");
    var nested = drawer.querySelector(".drawer__footer .cart-footer__main");
    var footer = drawer.querySelector(".drawer__footer .cart-footer");
    var moved = Array.from(drawer.children).find(function (el) {
      return el.classList.contains("cart-footer__main");
    });
    var main = nested || moved;
    if (!container || !main) return;
    var shouldNest = shortViewport.matches;
    if (shouldNest && !footer) return;
    if (shouldNest && nested && !moved) return;
    if (!shouldNest && !nested) return;

    if (observer) observer.disconnect();
    if (nested && moved && moved !== nested) moved.remove();
    if (shouldNest) {
      footer.appendChild(main);
    } else {
      container.insertAdjacentElement("afterend", main);
    }
    observe();
  }

  function schedule() {
    if (pendingFrame !== null) return;
    pendingFrame = window.requestAnimationFrame(function () {
      pendingFrame = null;
      placeFooter();
    });
  }

  function containsFooter(node) {
    return node.nodeType === 1 &&
      (node.matches(".cart-footer__main") || !!node.querySelector(".cart-footer__main"));
  }

  function onMutations(records) {
    var needsPlacement = records.some(function (record) {
      return record.type === "childList" &&
        Array.from(record.addedNodes).some(containsFooter);
    });
    if (needsPlacement) schedule();
  }

  function refresh() {
    var next = document.getElementById("CartDrawer");
    if (next !== drawer) {
      if (observer) observer.disconnect();
      drawer = next;
      observer = drawer && window.MutationObserver ? new MutationObserver(onMutations) : null;
      observe();
    }
    placeFooter();
  }

  window.TMCartDrawerFooter = { refresh: refresh };
  shortViewport.addEventListener("change", schedule);
  document.addEventListener("shopify:section:load", refresh);
  document.addEventListener("shopify:section:unload", function (event) {
    if (drawer && event.target.contains(drawer)) {
      if (observer) observer.disconnect();
      if (pendingFrame !== null) window.cancelAnimationFrame(pendingFrame);
      pendingFrame = null;
      drawer = null;
    }
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refresh, { once: true });
  } else {
    refresh();
  }
})();